var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-flex-col u-col-center result-box"},[_c('img',{staticClass:"result-img",attrs:{"src":_vm.imgUrl,"alt":""}}),_c('div',{staticClass:"result-font"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"result-desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }